import type { Invoice, InvoiceOrEstimate, Payment } from '~/types'

export const aggregateInvoices = (
  invoices: InvoiceOrEstimate[],
): InvoiceOrEstimate | null => {
  if (invoices.length === 0) return null
  if (invoices.length === 1) return invoices[0]

  const firstInvoice = invoices[0]
  const combined = {
    ...firstInvoice,
    id: invoices.map((inv) => inv.id).join(','),
    subtotal: invoices.reduce((sum, inv) => sum + (inv.subtotal || 0), 0),
    additionalDiscount: invoices.reduce(
      (sum, inv) => sum + (inv.additionalDiscount || 0),
      0,
    ),
    totalDiscount: invoices.reduce(
      (sum, inv) => sum + (inv.totalDiscount || 0),
      0,
    ),
    totalTax: invoices.reduce((sum, inv) => sum + (inv.totalTax || 0), 0),
    dueToPay: invoices.reduce(
      (sum, inv) => sum + (inv.dueToPay || inv.dueToPayNoFee || 0),
      0,
    ),
    dueToPayNoFee: invoices.reduce(
      (sum, inv) => sum + (inv.dueToPayNoFee || 0),
      0,
    ),
    requiredDeposit: invoices.reduce(
      (sum, inv) => sum + (inv.requiredDeposit || 0),
      0,
    ),
    requiredDepositAmountNoFee: invoices.reduce(
      (sum, inv) => sum + ((inv as any).requiredDepositAmountNoFee || 0),
      0,
    ),
    amountNoFee: invoices.reduce((sum, inv) => sum + (inv.amountNoFee || 0), 0),
    serviceFee: invoices.reduce((sum, inv) => sum + (inv.serviceFee || 0), 0),
    paidAmount: invoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0),
    payments: invoices.reduce(
      (acc, inv) => [...acc, ...(inv.payments || [])],
      [] as Payment[],
    ),
  }

  return combined
}

export const processSelectedInvoicesForPosVerifone = (
  unpaidInvoices: any[],
  selectedInvoiceIds: string[],
  shouldShowBraintreeFlow: boolean,
): {
  combinedInvoice: InvoiceOrEstimate | null
  selectedInvoices: InvoiceOrEstimate[]
} => {
  if (!shouldShowBraintreeFlow) {
    return {
      selectedInvoices: [],
      combinedInvoice: null,
    }
  }

  const selectedUnpaidInvoices = unpaidInvoices.filter((invoice: any) =>
    selectedInvoiceIds.includes(invoice.id),
  )

  const selectedInvoices = selectedUnpaidInvoices.map(
    (invoice: Invoice) => invoice as InvoiceOrEstimate,
  )

  const combinedInvoice = aggregateInvoices(selectedInvoices)

  return {
    selectedInvoices,
    combinedInvoice,
  }
}
